var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "goodsfreightReduction" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from1 },
        on: { Refresh: _vm.Refresh, search: _vm.search },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c(
                  "el-button",
                  { attrs: { type: "warning" }, on: { click: _vm.allclick } },
                  [_vm._v("新增")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "80",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplier_title",
                  align: "center",
                  label: "供应商名称",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _c("div", [_vm._v(_vm._s(scope.row.supplier_title))]),
                          _c("div", [
                            _vm._v(_vm._s(scope.row.supplier_mobile)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistic_name",
                  align: "center",
                  label: "集配中心",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyer_fullname",
                  align: "center",
                  label: "对接业务",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _c("div", [_vm._v(_vm._s(scope.row.buyer_fullname))]),
                          _c("div", [_vm._v(_vm._s(scope.row.buyer_mobile))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "product_title",
                  align: "center",
                  label: "商品名称",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", { attrs: { type: "text" } }, [
                          _vm._v(_vm._s(scope.row.product_title)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "sku_code", align: "center", label: "货号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandelDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.sku_code))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "start_time_text",
                  align: "center",
                  label: "生效时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.start_time_text) +
                            "-" +
                            _vm._s(scope.row.end_time_text) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "discount_text",
                  align: "center",
                  label: "折扣\n",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status_type",
                  align: "center",
                  label: "状态\n",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operator_name",
                  align: "center",
                  label: "创建人",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": 50,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("GoodsDetails", { ref: "GoodsDetailsref" }),
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: !_vm.ruleForm.id ? "添加商品折扣" : "编辑商品折扣",
                visible: _vm.centerDialogVisible,
                width: "500px",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contents" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "添加商品", prop: "sku_code" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "302px" } },
                            [
                              _c("el-autocomplete", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "fetch-suggestions": (queryString, cb) =>
                                    _vm.querySearchAsync("1", queryString, cb),
                                  placeholder: "输入商品名称/货号",
                                },
                                on: { select: _vm.handleSelect },
                                model: {
                                  value: _vm.ruleForm.product_title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "product_title", $$v)
                                  },
                                  expression: "ruleForm.product_title",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "折扣", prop: "discount_percent" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "302px" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "上架状态",
                                  },
                                  model: {
                                    value: _vm.ruleForm.discount_percent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "discount_percent",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.discount_percent",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "免运费", value: 0 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "1折", value: 10 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "2折", value: 20 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "3折", value: 30 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "4折", value: 40 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "5折", value: 50 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "6折", value: 60 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "7折", value: 70 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "8折", value: 80 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "9折", value: 90 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "无折扣", value: 100 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "有效期", prop: "end_time" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetimerange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  format: "yyyy-MM-dd HH:mm",
                                  "value-format": "yyyy-MM-dd HH:mm",
                                },
                                on: { change: _vm.startchanghe },
                                model: {
                                  value: _vm.value1,
                                  callback: function ($$v) {
                                    _vm.value1 = $$v
                                  },
                                  expression: "value1",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.ruleFormqr },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }